import {Validators} from "@angular/forms";
import {CreateComponentForm} from "../types/create-component.types";

export const createComponentFormFields: Array<CreateComponentForm> = [
  {
    label: 'Наименование компонента',
    fieldName: 'componentName',
    validators: [ Validators.required ],
    type: 'text'
  },
  {
    label: 'Наименование поставщика',
    fieldName: 'supplierName',
    type: 'text'
  },
  {
    label: 'ИНН поставщика',
    fieldName: 'supplierInn',
    type: 'text'
  },
  {
    label: 'ФИО руководителя',
    fieldName: 'directorFullName',
    type: 'text'
  },
  {
    label: 'Юридический адрес',
    fieldName: 'legalAddress',
    type: 'text'
  },
  {
    label: 'Почтовый адрес',
    fieldName: 'postalAddress',
    type: 'text'
  },
  {
    label: 'Контактное лицо',
    fieldName: 'contactPerson',
    type: "text"
  },
  {
    label: 'Контактный телефон',
    fieldName: 'contactPhone',
    type: 'tel'
  },
  {
    label: 'Контактная почта',
    fieldName: 'contactEmail',
    type: "email"
  }
]
